import { Crown } from 'lucide-react';
import { Helmet } from 'react-helmet-async';

export default function CrownCattlePage() {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <Helmet>
        <title>Crown & Cattle - Premium Meats | BlackBook</title>
        <meta name="description" content="Crown & Cattle - Grass-fed. Organic. Cage-free. Premium quality meats for the community." />
        
        <meta property="og:title" content="Crown & Cattle - Premium Meats | BlackBook" />
        <meta property="og:description" content="Grass-fed. Organic. Cage-free. Premium quality meats." />
        <meta property="og:image" content="https://www.blackbook.family/logo.jpeg" />
        <meta property="og:url" content="https://www.blackbook.family/crowncattle" />
        <meta property="og:type" content="website" />
        
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Crown & Cattle - Premium Meats" />
        <meta name="twitter:description" content="Grass-fed. Organic. Cage-free." />
        <meta name="twitter:image" content="https://www.blackbook.family/logo.jpeg" />
      </Helmet>
      <div className="text-center">
        <div className="relative inline-block mb-6">
          <h1 className="text-6xl font-bold text-white">
            <span className="relative inline-block">
              <Crown 
                className="text-yellow-500 absolute -top-8 -left-2 transform -rotate-12" 
                size={48} 
              />
              C
            </span>
            rown & Cattle
          </h1>
        </div>
        <p className="text-2xl text-white font-medium mt-4">
          Grass-fed. Organic. Cage-free.
        </p>
      </div>
    </div>
  );
}
